import localforage from 'localforage';
import { platformService } from '../services/platform.service';
import { AxiosResponse } from 'axios';

interface SubscriptionStatus {
  status: string,
  timeCached: number
}

const invalidationPeriod = 24 * 60 * 60 * 1000; // 24Hrs
const cacheSchema: LocalForageOptions = {
  driver: localforage.INDEXEDDB,
  name: 'tikit',
  storeName: 'subscription',
  version: 1
};
const cache: LocalForage = localforage.createInstance(cacheSchema);

let observer: Promise<AxiosResponse> = null;

const getSubscription = async (): Promise<AxiosResponse> => {
  if (!observer) {
    const api = new platformService();
    observer = api.checkSubscription();
    observer.then(r => cache.setItem<SubscriptionStatus>('SubscriptionStatus', { status: r.data, timeCached: Date.now() }).then(() => observer = null));
  }

  return observer;
}
export const clearSubscriptionCache = async () => await cache.clear();
export const checkSubscription = async (): Promise<string> => {
  const result = await cache.getItem<SubscriptionStatus>('SubscriptionStatus');

  if (result === undefined || result === null || (Date.now() - result.timeCached) > invalidationPeriod)
    return new Promise<string>(resolve => getSubscription().then(rsp => resolve(rsp.data)));

  return result.status;
};